<template>
  <div
    class="cursor-pointer w-full"
    @click="gotoHome"
  >
    <div class="flex items-center gap-3.5">
      <img
        class="h-[45px] w-[45px] rounded-lg object-cover"
        :src="logoPath"
        alt="logo"
        @click="gotoHome"
      />
      <!-- iMarketing -->
      <div class="text-white text-3xl font-medium">iMarketing</div>
    </div>
  </div>
</template>

<script setup lang="ts">
// import logo from '@/assets/logo.png';
import { computed } from 'vue';
import { useGoto } from '@/router/goto';

defineProps({
  short: {
    type: Boolean,
    default: false,
  },
});

const logoMap = {
  default: 'https://static.aix.intlgame.cn/imarketing/img/logo-48.png',
};

const logoPath = computed(() => logoMap.default);

const { gotoHome } = useGoto();
</script>
